const { debounce } = window.BAO.Utils

class AnnouncementBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.desktopSpeed = Number(this.dataset.desktopSpeed) * 1000 || 30000
    this.mobileSpeed = Number(this.dataset.mobileSpeed) * 1000 || 30000

    this.desktopAnimationType = this.dataset.desktopAnimationType || 'opacity'
    this.mobileAnimationType = this.dataset.mobileAnimationType || 'slide'

    this.observeHeight()

    if (this.els.slide.elements.length <= 1) {
      this.els.slides.element.setAttribute('data-single-slide', 'true')
      return
    }

    this.carousel = this.setupCarousel()
  }

  disconnectedCallback () {
    super.disconnectedCallback?.()
    this.heightObserver?.disconnect()
  }

  observeHeight () {
    let lastHeight = 0

    const updateHeight = () => {
      const height = Math.ceil(this.getBoundingClientRect().height)
      if (height === lastHeight) return
      lastHeight = height
      document.documentElement.style.setProperty(
        '--Announcement_Height',
        `${height}px`,
      )
    }

    updateHeight()

    this.heightObserver = new ResizeObserver(updateHeight)
    this.heightObserver.observe(this)
  }

  setupListeners () {
    const breakpoint = window.matchMedia('(min-width: 901px)')
    this.listeners.add(breakpoint, 'change', this.carouselSwitcher.bind(this))

    this.listeners.add(
      window,
      'resize',
      debounce(this.resetCarousel.bind(this), 300),
    )
  }

  carouselSwitcher () {
    if (!this.carousel) return
    this.carousel.destroy()
    this.carousel = this.setupCarousel()
  }

  resetCarousel () {
    if (!this.carousel) return
    this.carousel.moveToIdx(0, false, { duration: 0 })
    this.carousel.update()
  }

  setupCarousel () {
    this.els.slides.element.classList.add('keen-slider')
    this.els.slide.elements.forEach(el => el.classList.add('keen-slider__slide'))
    let pauseLength = 0

    if (window.innerWidth > 900) {
      if (this.desktopAnimationType === 'opacity') {
        this.speed = 1000
        pauseLength = 3
      } else {
        this.speed = this.desktopSpeed
      }
    } else {
      if (this.mobileAnimationType === 'opacity') {
        this.speed = 1000
        pauseLength = 3
      } else {
        this.speed = this.mobileSpeed
      }
    }

    const opacityOptions = {
      selector: this.els.slide.selector,
      loop: true,
      defaultAnimation: {
        duration: this.speed,
        easing: (t) => t,
      },
      detailsChanged: (s) => {
        s.slides.forEach((element, idx) => {
          element.style.opacity = s.track.details.slides[idx].portion
          element.style.pointerEvents = idx === s.track.details.rel ? 'all' : 'none'
        })
      },
      renderMode: 'custom',
    }

    const slideOptions = {
      selector: this.els.slide.selector,
      loop: true,
      mode: 'snap',
      slides: {
        perView: 1,
        spacing: 0,
      },
      defaultAnimation: {
        duration: this.speed,
        easing: (t) => t,
      },
      detailsChanged: () => {}
    }

    let options = slideOptions

    if (window.innerWidth > 900) {
      if (this.desktopAnimationType === 'opacity') {
        options = opacityOptions
      }
    } else {
      if (this.mobileAnimationType === 'opacity') {
        options = opacityOptions
      }
    }

    return new window.KeenSlider(
      this.els.slides.element,
      options,
      [
        window.BAO.Carousel.plugins.setInitialised(),
        window.BAO.Carousel.plugins.useAutoplay(pauseLength),
      ]
    )
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
